export const CONFIG = {
  rangeDivider: ':',

  companies: {
    pcna: 'PCNA',
    hit: 'Hit Promo',
  },
  configurationTypes: {
    Decorated: 'Decorated',
    Blank: 'Blank',
  },
  priceTypes: {
    List: 'List',
    Customer: 'Customer',
  },
  importTypes: {
    0: 'NEW',
    1: 'PENDING',
    2: 'FULLFILD',
    3: 'ERROR',
    4: 'WARNING',
  }
}